import { useParams, Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { FeaturedPlayer } from "@/components/FeaturedPlayer";
import { useAuth } from "@/context/AuthContext";
import { ArrowLeft, Sparkles } from "lucide-react";

export default function PublicWatch() {
  const { id } = useParams();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-6 md:px-8 py-12" data-testid="public-watch-page">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8" data-testid="watch-back">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <FeaturedPlayer courseId={id} />
        {!user && (
          <div className="mt-8 border border-border bg-card p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-testid="watch-signup-cta">
            <div>
              <p className="font-display text-lg font-bold flex items-center gap-2"><Sparkles className="h-5 w-5 text-primary" /> Want courses on any topic?</p>
              <p className="text-sm text-muted-foreground mt-1">Create a free account to generate your own and save them to your library.</p>
            </div>
            <Link to="/register" className="shrink-0 h-11 px-6 bg-primary text-white font-semibold hover:opacity-90 transition-opacity inline-flex items-center" data-testid="watch-signup-button">
              Sign up free
            </Link>
          </div>
        )}
      </main>
    </div>
  );
}
